import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { LoansContractDetailsComponent } from '../loans-contract-details.component';
import { AppComponent } from 'src/app/app.component';

@Component({
  selector: 'app-completed-loan',
  templateUrl: './completed-loan.component.html',
  styleUrls: ['./completed-loan.component.scss']
})
export class CompletedLoanComponent implements OnInit {

  @Input() contractData: any
  @ViewChild('closeBtn') closeBtn: ElementRef;
  errorMsg: boolean;

  role: any;

  constructor(private contractDetails: LoansContractDetailsComponent, private appComp: AppComponent, private authService: AuthenticationService) { }

  ngOnInit(): void {

    this.role = this.authService.getUserRole();
  }

  completeContract(){
    this.appComp.loading = true;
    this.errorMsg = false;
    let contract = {
      ...this.contractData
    }
    contract.isCompleted = 1;
    //stringify
    let keys = Object.keys(contract);
    keys.forEach((key, index) => {
      if(typeof contract[key] == 'object'){
        let string =  JSON.stringify(contract[key]);
        if(string[0] == "{" || string[0] == "["){
          contract[key] = JSON.stringify(contract[key]);
        }
      }
    });
    console.log(contract);
    this.authService.updateLoanContract(contract).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.appComp.loading = false;
      this.contractDetails.getLoanContract(contract.id);

    }, err=>{
      console.log(err);
      this.appComp.loading = false;
      this.errorMsg = true;
    })
  }

}
